import { FunctionComponent } from "react";
import { RouteComponentProps } from "react-router-dom";
import InnerLayout from "../innerLayout/InnerLayout";

interface ChangeLogProps {
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}


export const ChangeLogPage : FunctionComponent<ChangeLogProps> = (props : ChangeLogProps) => {
    return (
        <InnerLayout 
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="none"
        >
            <>
                <h1 style={{paddingTop:30}}>Change Log</h1>

                <h2>Release Note, UI Update 01.06.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Group Play/Stop action for Playnow List Groups</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, UI Update 17.05.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Site Nested Playlist Groups Changes</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, UI Update 26.04.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Sky TV Guide: Description</li>                                                                        
                    </ul>
                </div>

                 <h2>Release Note, version: 0.9.6 22.02.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Sky TV Guide</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, UI Update 27.02.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Add Duplicate Mosaic Feature</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, version: 0.9.4 22.02.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Feature:</h3>
                    <ul>                    
                        <li>Weather Widget</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, version: 0.9.3 11.02.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Feature:</h3>
                    <ul>                    
                        <li>RSS Widget</li>                                                                        
                    </ul>
                </div>


                <h2>Release Note, UI Update 22.01.2026</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Improve Media Schedule</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, UI Update 01.10.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Dispay Campaign Creator and Create Date</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, version: 0.9.2 22.09.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Add SKY Q Power Command</li>                                                                        
                    </ul>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Decrease number of VAST requests</li>                                                                        
                    </ul>
                </div>

                <h2>Release Note, version: 0.9.1 04.09.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Support RTMP Stream</li>                                                                        
                    </ul>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Improve performance on Tag Managment Page</li>                                                                        
                    </ul>
                </div>
                <h2>Release Note, UI Update 06.08.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Network Playlist: Duplicate media to Groups</li>                                      
                        <li>Campaign Media: Media Substitution</li>                                      
                        <li>Playnow List Media: Display name of the list</li>                                      
                    </ul>
                </div>

                <h2>Release Note, UI Update 15.07.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>User can select Media Taxonomy Category and view it in Nested Playlist and PlayNow List</li>                                      
                    </ul>
                </div>

                <h2>Release Note, UI Update 03.07.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Navigation to Stream from TV Guided Look Page</li>                                      
                    </ul>
                </div>


                 <h2>Release Note, UI Update 02.07.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Playnow Autodeactivation</li>                                      
                    </ul>
                </div>

                <h2>Release Note, version: 0.9.0 09.06.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Hivestack Integration</li>                                      
                        <li>Vast Url: apply retry policy for firing 1x1 tracking pixel (Impression)</li>                                      
                    </ul>
                </div>

                <h2>Release Note, version: 0.8.2 09.06.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Vast Url Volume Processing</li>                                      
                    </ul>
                </div>

                <h2>Release Note, UI Update 26.05.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Share of Voice Column</li>                                      
                    </ul>
                </div>

                 <h2>Release Note, UI Update 15.05.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Show Flight Dates in Site Playlist</li>                                      
                        <li>Use UK format for dates in AdHoc Report</li>                                      
                    </ul>
                    
                    <h3>Fixes:</h3>
                     <ul>                    
                        <li>System Monitor: Colour schema for Available Space</li>  
                    </ul>
                </div>
                
                <h2>Release Note, version: 0.8.0 04.04.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Mosaic template: Local Web Page</li>                      
                        <li>New Media Type: Local Web Page</li>                                        
                    </ul>
                </div>
                
                <h2>Release Note, version: 0.7.0 10.03.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Mosaic template: Overlay Over Web Page</li>                      
                        <li>Transcode Profiles: support QHD</li>                                        
                        <li>Fix Network's Playlist Layout</li>                      
                    </ul>
                </div>

                <h2>Release Note, version: 0.6.0 04.02.2025</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Web View Media Element</li>                      
                        <li>Web View Mosaic Element</li>                      
                        <li>Player Media Download Schedule</li>                      
                        <li>Fixes</li>                      
                    </ul>
                </div>

                <h2>Release Note, UI Update 02.12.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Playlist SoV</li>                                      
                    </ul>
                </div>

                <h2>Release Note, UI Update 29.09.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Additional column for sum of duration per row and sum of total duration for Reporting Dashboard</li>                      
                        <li>Additional Split for Content Type and filter for Reporting Dashboard</li>                      
                    </ul>
                </div>

                <h2>Release Note, version: 0.4.0 01.07.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Play Now grouping and duplicate</li>                      
                        <li>Local Large File MiniPlayer</li>                      
                        <li>Support of SRT for Local Large Files</li>                      
                    </ul>
                </div>
                <h2>Release Note, UI Update 15.08.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Report Dashboard</li>                      
                    </ul>
                </div>

                <h2>Release Note, UI Update 29.07.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Filter by multiple tags and empty tag on network playlist</li>                      
                    </ul>
                </div>
                <h2>Release Note, UI Update 17.07.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Switch thumbnails generation to browser</li>
                        <li>Tag management page under Settings</li>                     
                        <li>New col to display scheduled date/time for media item inside each Play Now list</li>                                 
                    </ul>
                </div>
                <h2>Release Note, UI Update 09.07.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Clock ID In Media</li>
                        <li>Network Bested Playlist Export to CSV</li>                     
                    </ul>
                </div>
                <h2>Release Note, version: 0.3.6 01.07.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Local PlayNow</li>
                        <li>Both Type Reports scheduling to email (yesterday, week to date, last week, last 7 days, last month, month to date)</li>
                        <li>Network playlist Tags column, with a tag filter</li>
                        <li>Monitoring dashboard: Rename/Expand</li>
                        <li>Expand all and collapse all button on Network playlist and Player monitor page</li>
                        <li>Double the page length for Campaign, Network, Stream, PlayNow, Player</li>
                    </ul>
                </div>
                <h2>Release Note, version: 0.3.5 16.06.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Macrosed VAST urls</li>
                        <li>PDF Generation of TV Guided Look</li>
                        <li>Play Now - Implement this logic without changing Tags in PlayList/Player on the Fly + add columns of current players that are playing each playlist</li>
                        <li>Play Now - With on the fly changes in Play now for tag and network</li>
                        <li>Play Now - Start/stop change log table with playlist, player, action, date and time, user that performed action</li>
                        <li>Play Now - Lockable player for multiple activated Play Now in sequence</li>
                    </ul>
                </div>

                <h2>Release Note, UI Update 28.05.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Campaign ID field</li>
                        <li>Monitor page filtering, grouping and reordering, links to Stream record and Player config page</li>
                        <li>Rename Sites to Networks</li>
                        <li>Reorder items in the Menu</li>
                        <li>Rename "Players Monitoring" to "Player Monitor Dashboard"</li>
                    </ul>
                    <br></br>              
                    <h3>Fixes:</h3>
                    <ul>                    
                        <li>Fix Time Sensetive Schedule in Play Now</li>
                        <li>Fix Stream record stuck in TV guide after deletion</li>
                        <li>Performace improvement</li>
                    </ul>
                </div>
                <h2>Release Note, version: 0.3.2 09.05.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Bookend nested playslit wrapping around Stream content</li>
                        <li>Media item site playlist grouping and bulk operation</li>
                        <li>Expandable list for paused media items in site playlist</li>
                        <li>Priority stream visualisation in TV guide look</li>
                    </ul>
                </div>
                <h2>Release Note, version: 0.3.1 29.03.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>                    
                        <li>Time sensitive scheduling in Play Now playlist</li>
                        <li>Player tagging in Play Now playlist</li>
                        <li>Advanced day parting hour selection</li>
                        <li>Duplicate Repeat Stream</li>
                        <li>Advanced colour-striped screen alert</li>
                        <li>Player monitor page with auto refresh, screenshots and filter</li>
                    </ul>
                </div>
                <h2>Release Note, version: 0.3.0 29.02.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Upgrade to .Net 8</li>
                    </ul>
                </div>
                <h2>Release Note, version: 0.2.14 04.02.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Collecting new metric from Player: Memory</li>
                    </ul>
                </div>

                <h2>Release Note - UI Update 24.01.2024</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>New filter for players on dashboard: All, Enabled, Disabled</li>
                    </ul>
                </div>

                <h2>Release Note, version: 0.2.13 22.11.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Holding image support for replacing on screen colour stripe error message</li>
                        <li>Player level day parting override</li>
                    </ul>
                </div>

                <h2>Release Note, version: 0.2.12 19.10.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Player Volume Profiles</li>
                        <li>Real live SoV mini report for the currently live assets</li>
                    </ul>
                </div>

                <h2>Release Note, version: 0.2.11 28.09.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Proxy Server for external HTTP calls</li>
                    </ul>
                </div>

                <h2>Release Note - UI Update 24.08.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Give user options to select And or OR relationship in player tagging in Stream</li>
                    </ul>
                </div>

                <h2>Release Note, version: 0.2.10 10.07.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Dolby integration for media asset transcoding</li>
                    </ul>
                </div>

                <h2>Release Note - UI Update 05.07.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Allow to create Back to Back Priority Streams</li>
                    </ul>
                </div>

                <h2>Release Note, version: 0.2.9 14.06.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Player restart button for instant restart</li>
                        <li>Schedule large size local media files</li>
                        <li>Enforce resend of remote TV IR signal for the current scheduled Stream</li>
                    </ul>
                </div>

                <h2>Release Note - UI Update 23.05.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Data retention policy</li>
                        <li>Screenshot for 5 days</li>
                        <li>Option to retain/archieve a campaign</li>
                        <li>Logging errors, requests and telemetry</li>
                        <li>User alert on server error</li>
                    </ul>
                </div>

                <h2>Release Note,  27.04.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Multiple TV channel mapping profiles</li>
                    </ul>
                    <br></br>
                    <h3>Fix:</h3>
                    <ul>                    
                        <li>Wrong campaign alert messages (in progress)</li>
                    </ul>
                </div>

                <h2>Release Note, version 0.2.8  19.04.2023</h2>
                <div style={{marginLeft: 25, marginBottom: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>Include/Exclude player tags in Streams</li>
                        <li>Show and edit added VAST URLs</li>
                        <li>VAST 2.0 FreeWheel and Publica spec support</li>
                        <li>Content labeling in Site playlist and share of airtime calculation</li>
                    </ul>
                    <br></br>
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Improve colour schema on Campaign Timeline Dashboard</li>
                    </ul>
                </div>
                

                <h2>Release Note, version 0.2.7  04.04.2023</h2>
                <div style={{marginLeft: 25}}>
                    <h3>New Features:</h3>
                    <ul>
                        <li>In platform alert messaging</li>
                        <li>Email alert messaging</li>
                        <li>Side app to detect crash and restart Cplayer</li>
                        <li>CPlayer Freeze detection</li>
                        <li>Time sensitive scheduling for media in nested playlist</li>
                        <li>Schedule repeat stream</li>
                        <li>Display player version on the player page</li>
                    </ul>
                    <br></br>                   
                    <h3>Improvements:</h3>
                    <ul>                    
                        <li>Rename Priority Stream Tab to Streaming</li>
                        <li>IImprove remote TV channel change IR solution</li>
                        <li>Sort Channels in alphabet order</li>
                        <li>Optimize priority stream media page load</li>
                        <li>Fix column width in campaign media time schedule</li>
                        <li>Display player version on the Player List page</li>
                        <li>Improve stream stability when Cplayer starts up with scheduled stream</li>
                    </ul>
                </div>
                
            </>           
        </InnerLayout>
    )
}